const ViewButton = () => {
    return (
        <button class="btn btn-info" style={{ padding: "0 6px 6px" }}>View</button>
    )
}
export default ViewButton